import { styled } from '@vebox/etui-system';
import { Component, createElement } from 'react';
import { c as _defineProperty, a as _objectSpread2 } from './_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';

const WrapperDiv = styled.div`
  overflow-x: hidden;
`;
const ScrollDiv = styled(Div)`
  overflow-x: ${props => props.isResponsive ? 'none' : 'auto'};
  white-space: nowrap;
  display: flex;
  height: 100%;
  width: ${({
  width
}) => width && typeof width === 'number' && width > 1500 ? `${width}px` : '100%'};
`;
const GridDiv = styled(Div)`
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: ${props => props.isResponsive ? 'auto' : '920px'};
  min-height: 0;
`;
const GridContentDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-start;
  width: 100%;
  position: relative;
`;

class CalendarInfoBar extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "styles", {
      content: {
        padding: '15px',
        width: '100%',
        maxWidth: '1280px',
        justifyContent: 'space-between'
      },
      item: {
        justifyContent: 'space-evenly'
      },
      colorBrick: {
        height: '20px',
        width: '20px'
      }
    });
    this.state = {};
  }
  render() {
    return /*#__PURE__*/createElement(WrapperDiv, null, /*#__PURE__*/createElement(GridContentDiv, {
      style: this.styles.content
    }, this.props.items.map(item => /*#__PURE__*/createElement(GridContentDiv, {
      key: item.name,
      style: this.styles.item
    }, /*#__PURE__*/createElement(Div, {
      style: _objectSpread2(_objectSpread2({}, this.styles.colorBrick), {}, {
        backgroundColor: item.color
      })
    }), /*#__PURE__*/createElement(Div, null, item.name)))));
  }
}
_defineProperty(CalendarInfoBar, "defaultProps", {
  items: [{
    name: 'Schedule 1',
    color: '#00FF00'
  }, {
    name: 'Schedule 2',
    color: '#00FF00'
  }, {
    name: 'Schedule 3',
    color: '#00FF00'
  }, {
    name: 'Schedule 4',
    color: '#00FF00'
  }, {
    name: 'Schedule 5',
    color: '#00FF00'
  }]
});

export { CalendarInfoBar as C, GridDiv as G, ScrollDiv as S, GridContentDiv as a };
